export const validation = {
	badge: {
		validated: "Validated",
		pending: "Pending validation",
		preExisting: "Pre-existing",
	},
	filter: {
		label: "Status",
		all: "All",
		pending: "Pending validation",
		validated: "Validated",
	},
	banner: {
		title: "You have fiscal data to validate!",
		message: "Confirm the data to use these fiscal profiles.",
	},
	card: {
		confirmAction: "Confirm data",
		validateAction: "Validate data",
		viewDetails: "See details",
	},
	drawerNotice: {
		pendingValidation: "Validate the data to use this fiscal profile",
	},
	modalConfirm: {
		title: "Confirm fiscal data",
		message:
			"Are you sure you want to validate this fiscal profile? Once confirmed it will be available for use in the system.",
		confirm: "Confirm data",
		success: "Data validated successfully!",
	},
	modalReject: {
		title: "Reject fiscal data",
		message:
			"Are you sure you want to reject these changes? The record will revert to the previous state.",
		confirm: "Confirm rejection",
		success: "Data rejected.",
	},
	infoBlock: {
		title: "Fiscal data validation",
		validatedAt: "Validation date/time",
		validatedBy: "Validated by",
		newBadge: "New",
	},
	drawerFooter: {
		confirmData: "Confirm data",
		reject: "Reject",
	},
	form: {
		saveAndValidate: "Save and Validate",
		saveAndValidateSuccess: "Saved and validated successfully.",
	},
};
